import { render, staticRenderFns } from "./RiskPermitWorkDocWrite.vue?vue&type=template&id=59e50928&scoped=true"
import script from "./RiskPermitWorkDocWrite.vue?vue&type=script&lang=js"
export * from "./RiskPermitWorkDocWrite.vue?vue&type=script&lang=js"
import style0 from "./RiskPermitWorkDocWrite.vue?vue&type=style&index=0&id=59e50928&prod&lang=scss&scoped=true"
import style1 from "./RiskPermitWorkDocWrite.vue?vue&type=style&index=1&id=59e50928&prod&lang=scss&scoped=true"
import style2 from "./RiskPermitWorkDocWrite.vue?vue&type=style&index=2&id=59e50928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e50928",
  null
  
)

export default component.exports